<template>
    <div>
        <b-card no-body class="b-r-3 dashboardCard">
            <b-list-group flush>
                <b-list-group-item>
                    <div class="dashboardHeader">
                        {{ $t("lbl_EMPBE_eBoothSubscription") }}
                    </div>
                    <b-card-body body-class="p-y-25">
                        <b-card-text>
                            <h2 class="text-center f-36 Roboto font-weight-bold">{{
                                BoothName
                            }}</h2>
                            <div class="text-center f-12 font-weight-bold dashboard-info" v-if="BoothName != ''">
                                {{
                                    $t("lbl_EMPBE_EffectivePeriod").replace(ReplaceText_StartDate,
                                        DisplayDate(data.eboothFrom)).replace(ReplaceText_EndDate, DisplayDate(data.eboothTo))
                                }}
                            </div>
                        </b-card-text>
                    </b-card-body>

                </b-list-group-item>
                <b-list-group-item>
                    <div class="dashboardHeader">
                        {{ $t("lbl_EMPBE_StatusOfEBooth") }}
                    </div>
                    <div class="row mt-3 mb-3">
                        <div class="col-6 mt-3 f-12 font-weight-bold dashboard-info">{{ $t("lbl_EMPBE_CompanyInfoCenter") }}
                            <i class="fa fa-info-circle m-l-5 f-16" id="CompanyPercentageInfo"></i>
                            <b-tooltip target="CompanyPercentageInfo" triggers="hover" placement="right">
                                <div v-html="$t('lbl_EMPBE_CompanyPercentageInfo')">

                                </div>
                            </b-tooltip>
                        </div>
                        <div class="col-6 mt-3">
                            <div class="font-weight-bold f-16">{{
                                $t("lbl_EMPBE_CompanyCompletePercentage").replace(ReplaceText_percentageOfProfileCompletion,
                                    CompanyPercentage)
                            }}
                            </div>
                            <div class="mt-2 f-12 font-weight-bold dashboard-info">{{
                                $t("lbl_EMPBE_LastUpdatedOn").replace(ReplaceText_LastUpdatedDate,
                                    DisplayDate(CompanyLastUpdateDate))
                            }}</div>
                        </div>
                        <div class="col-6 mt-3 f-12 font-weight-bold dashboard-info">
                            {{ $t("lbl_EMPBE_ProductInfo") }}
                            <i class="fa fa-info-circle m-l-5 f-16" id="ProductPercentageInfo"></i>
                            <b-tooltip target="ProductPercentageInfo" triggers="hover" placement="right">
                                <div v-html="$t('lbl_EMPBE_ProductPercentageInfo')">

                                </div>
                            </b-tooltip>
                        </div>
                        <div class="col-6 mt-3">
                            <div class="font-weight-bold f-16">
                                {{
                                    $t("lbl_EMPBE_PostedProductCount").replace(ReplaceText_noOfPostedProducts,
                                        noOfPostedProducts).replace(ReplaceText_noOfEntitledProducts, noOfEntitledProducts)
                                }}
                            </div>

                            <div class="mt-2 f-12 font-weight-bold dashboard-info">
                                {{
                                    $t("lbl_EMPBE_LastUpdatedOn").replace(ReplaceText_LastUpdatedDate,
                                        DisplayDate(ProductLastUpdateDate))
                                }}
                            </div>
                        </div>
                    </div>
                </b-list-group-item>
            </b-list-group>

            <b-collapse visible :id="'eBoothSubscriptionCollapse'">

                <b-list-group flush>
                    <b-list-group-item class="p-0"></b-list-group-item>
                    <b-list-group-item>
                        <div class="dashboardHeader">
                            {{ $t("lbl_EMPBE_Entitlements") }}
                        </div>
                        <div class="dashboardEntitlement mb-3" v-for="(item) in BoothEnt">
                            <div class="mt-3">
                                <i class="fa fa-check f-20"></i>
                                <span class="m-l-10">{{ item }}</span>
                            </div>
                        </div>
                    </b-list-group-item>
                </b-list-group>
                <b-card-footer footer-class="b-t-light dashboardCardFoother">
                    <div class="d-flex align-items-center justify-content-center">
                        <b-button class="dashboard-btn" v-b-toggle="'MoreAbouteBooth'"
                            v-bind:t_label="'EMPBE_Dashboard_MoreAbouteBooth'" variant="outline-light">{{
                                $t('lbl_EMPBE_MoreAbouteBooth') }}</b-button>
                    </div>
                </b-card-footer>
            </b-collapse>
            <div class="cardExpendButton dashboardCard">
                <feather type="chevron-down" @click="expend = !expend" v-if="!expend"
                    v-b-toggle="'eBoothSubscriptionCollapse'"></feather>
                <feather type="chevron-up" @click="expend = !expend" v-if="expend"
                    v-b-toggle="'eBoothSubscriptionCollapse'"></feather>
            </div>
        </b-card>
        <b-sidebar backdrop id="MoreAbouteBooth" :title="$t('lbl_EMPBE_MoreAbouteBooth')" right bg-variant="grey"
            :shadow="true">
            <div class="tab-pane active p-20">
                <img :src="imagePath" class="w-100" />
            </div>
        </b-sidebar>
    </div>
</template>
<script>
import { userService } from '../../../_services'
var defaultDatetimeString = '0001-01-01 00:00:00'

export default {
    props: ["data", "PaymentItemData", "companyItemData"],
    data() {
        return {
            expend: true,
            membershipExpiryDate: '',
            adExpiryDate: '',
            lastSubmitDate: '',
            isExpiremembershipExpiryDate: this.membershipExpiryDate < new Date(),
            isExpireadExpiryDate: this.adExpiryDate < new Date(),
            isExpirelastSubmitDate: this.lastSubmitDate < new Date(),
            ReplaceText_noOfPostedProducts: '{{noOfPostedProducts}}',
            ReplaceText_noOfEntitledProducts: '{{noOfEntitledProducts}}',
            ReplaceText_LastUpdatedDate: '{{LastUpdatedDate}}',
            ReplaceText_percentageOfProfileCompletion: '{{percentageOfProfileCompletion}}',
            ReplaceText_StartDate: '{{StartDate}}',
            ReplaceText_EndDate: '{{EndDate}}',
        }
    },
    computed: {
        langid() {
            return localStorage.getItem("currentLangId")
        },
        BoothName() {
            return this.langid == 1252 ? this.data.boothEn : this.langid == 936 ? this.data.boothSc : this.data.boothTc
        },
        imagePath() {
            var langPath = this.langid == 1252 ? "en" : "cn";
            return 'https://cdn.adsalecdn.com/EMP/Backend/Images/Dashboard/eBooth_' + langPath + '.jpg'
        },
        BoothEnt() {
            var ent = this.langid == 1252 ? this.data.boothEntEn : this.langid == 936 ? this.data.boothEntSc : this.data.boothEntTc
            if (ent == undefined || ent == "") return []
            return ent.split('- ').filter(x => x != '');
        },
        productRecord() {
            if (this.PaymentItemData) {
                var productRecord = this.PaymentItemData.filter(x => x.paymentItemId == 1)
                if (productRecord.length > 0) {
                    return productRecord[0]
                }
            }
            return {}
        },
        noOfPostedProducts() {
            return this.productRecord.usedCount ? this.productRecord.usedCount : 0;
        },
        noOfEntitledProducts() {
            return this.productRecord.qty ? this.productRecord.qty : 0;
        },
        ProductLastUpdateDate() {
            return this.productRecord.updatedDate;
        },
        CompanyPercentage() {
            return this.companyItemData.percentage;
        },
        CompanyLastUpdateDate() {
            return this.companyItemData.updateDate;
        },
    },
    mounted() {
    },
    methods: {
        DisplayDate(dateStr) {
            if (dateStr == undefined) return "";
            var date = new Date(dateStr)
            try {
                var mm = date.getMonth() + 1; // getMonth() is zero-based
                var dd = date.getDate();
                if (mm == NaN) return "";
                return [date.getFullYear() + "-",
                (mm > 9 ? '' : '0') + mm + "-",
                (dd > 9 ? '' : '0') + dd
                ].join('');
            } catch (ex) {
                return "";
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.dashboardCard {
    box-shadow: 0 4px 4px 0 rgba(0, 0, 0, .25) !important;
    border-radius: 16px !important;
}
.card > .list-group:first-child {
    border-top-width: 0;
    border-radius: 16px !important;
}
</style>